





























import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

@Component
export default class ErrorMessage extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    get errorMessage() {
        return this.$store.getters['Viewport/currentErrorMessage'];
    }

    public dismissError(): void {
        this.$store.commit(Mutations.DISMISS_CURRENT_ERROR_MESSAGE);
    }
}
